import React, { createContext } from 'react';
import getVideoPlayer from '../players/mock';
export const AnalyticsContext = createContext({
    defaultGetVideoPlayer: getVideoPlayer,
});
export function AnalyticsProvider({ defaultGetVideoPlayer, defaultTimeInterval, children, }) {
    return (<AnalyticsContext.Provider value={{
            defaultGetVideoPlayer: defaultGetVideoPlayer,
            defaultTimeInterval,
        }}>
      {children}
    </AnalyticsContext.Provider>);
}
